<template>
  <div class="approval-container flex flex-col flex-col-jcsp">
    <div class="approval__header">
      <van-icon v-if="false" name="circle" :class="[
        'topcico',
        isSelectedAll ? 'sel' : ''
      ]" :size="18" @click="handleSelectAll">
        <span>全选</span>
      </van-icon>
    </div>
    <div class="approval__content">
      <van-list v-model="listLoading" :finished="finished" :finished-text="finishedText" @load="onLoadData"
        :immediate-check="false">

        <template v-for="(item, idx) in list">
          <div class="approval-item flex flex-row" :key="idx" @click="handleCheckboxItem(item, idx)">
            <div class="checkbox">
              <van-icon name="circle" :class="item.selected ? 'sel' : ''" :size="18">
              </van-icon>
            </div>
            <div class="approval-item__main">
              <div class="approval-item__header flex flex-row flex-row-aic">
                <div class="hb">
                  <div class="title">采购人</div>
                  <div class="ctx">{{ username }}</div>
                </div>
                <div class="hb">
                  <div class="title">采购时间</div>
                  <div class="ctx">{{ item.apply_date }}</div>
                </div>
              </div>
              <div class="approval-item__mid">
                <div class="hb">
                  <div class="title">采购事由</div>
                  <div class="ctx">{{ item.reason }}</div>
                </div>
              </div>
              <div class="approval-item__mid">
                <div class="hb">
                  <div class="title">采购物品</div>
                  <div class="ctx">{{ item.apply_goods | filterGoods }}</div>
                </div>
              </div>

            </div>
          </div>
        </template>

      </van-list>
      <my-empty v-show="showEmpty" tip="暂无数据" />
    </div>
    <div class="btn-container">
      <div class="btn-span" @click="handleConfirmForm">确定</div>
    </div>
  </div>
</template>

<script>

import { getRecordList } from '@/api/approveinfo'

import { SAVE_APPROVAL_NAME } from '@/utils/constant'
import { settingNavigationRight } from '@/utils/dingtalk'
import { mapState } from 'vuex'
export default {
  name: 'CApprovalForm',
  computed: {
    ...mapState('user', {
      username: state => state.name
    })
  },
  data: () => ({
    list: [],
    showEmpty: false,
    listLoading: false,
    finished: false,
    finishedText: '暂无更多数据了',
    pagination: {
      page: 1,
      page_num: 20
    },
    isSelectedAll: false,
  }),
  created() {
    this.navigationSetting()
    this.__list__()
  },
  methods: {
    // NOTE: 设置Right标题隐藏
    navigationSetting() {
      settingNavigationRight({
        show: false
      })
    },
    onLoadData() {
      this.__list__()
    },
    async __list__() {
      try {
        let sel = []

        if (this.$route.query && this.$route.query.sel) {
          sel = this.$route.query.sel.split(',')
        }

        const THAT = this

        const params = {
          ...THAT.pagination,
          group: 'form'
        }

        const result = await getRecordList(params)
        if (result.code === 1) {
          let list = result.data || []

          this.listLoading = false

          list = list.map(item => ({
            ...item,
            selected: sel.includes(String(item.id))
          }))

          if (list.length < THAT.pagination.page_num) THAT.finished = true

          else {
            THAT.pagination.page++
          }

          THAT.list = THAT.list.concat(list)
          if (THAT.finished && !THAT.list.length) {
            THAT.finishedText = ''
            THAT.showEmpty = true
          }
        }
      } catch (error) {
        console.log('%c __list__ >>>', 'background: blue; color: #fff', error);
      }
    },

    // Selecte All
    handleSelectAll() {
      this.isSelectedAll = !this.isSelectedAll
      this.list = this.list.map(item => ({
        ...item,
        selected: this.isSelectedAll
      }))
    },

    // Checkbox item
    handleCheckboxItem(item, idx) {
      // NOTE: 清空选中操作
      this.list = this.list.map(row => ({
        ...row,
        selected: false,
      }))

      this.$forceUpdate()
      // this.list[idx].selected = !item.selected
      this.$nextTick(() => {
        this.list[idx].selected = true
        // NOTE: 全选逻辑
        // let hasAll = this.list.every(item => (item.selected))
        // this.isSelectedAll = hasAll
        this.$forceUpdate()
      })
    },

    handleConfirmForm() {
      let arrs = this.list.filter(item => (item.selected))
      if (!arrs.length) return this.$toast('请选择采购单！')

      localStorage.setItem(SAVE_APPROVAL_NAME, JSON.stringify(arrs))

      this.$nextTick(() => {
        this.$router.push({
          name: 'CApprovalFormSel'
        })
      })

    }

  },
  filters: {
    filterGoods(goods) {
      if (!Array.isArray(goods)) return '/'
      if (!goods.length) return '/'
      return goods.map(good => (good.goods_name)).join('、')
    },
  }
}
</script>

<style lang="less" scoped>
.approval {
  &-container {
    padding-top: 10px;
    height: 100vh;
    box-sizing: border-box;
  }

  &__header {
    background-color: #fff;
    font-size: 16px;
    padding: 14px 12px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);

    span {
      margin-left: 10px;
    }
  }

  &__content {
    height: 0;
    flex: 1;
    background-color: #fff;
    overflow: auto;
  }
}

.approval-item {
  padding: 0 0 10px 10px;

  &:first-child {
    .approval-item__main {
      border-top: none;
    }
  }

  .checkbox {
    width: 60px;
    text-align: center;
  }

  &__main {
    width: 0;
    flex: 1;
    padding-top: 15px;
    border-top: 1px solid rgba(151, 151, 151, 0.3);

    .hb {
      font-size: 0;

      .title {
        font-size: 12px;
        font-weight: 400;
        color: #727273;
        line-height: 18px;
      }

      .ctx {
        font-size: 16px;
        font-weight: 400;
        color: #191A1E;
        line-height: 24px;
      }
    }
  }

  &__header {
    justify-content: space-between;
    padding-right: 20px;
    padding-bottom: 15px;
  }

  &__mid {
    padding-right: 20px;
    padding-bottom: 15px;
  }
}

// circle box
.van-icon.van-icon-circle {
  position: relative;
  z-index: 1;
  color: rgba(200, 200, 201, 1);

  &.sel {
    color: rgba(50, 144, 196, 1);

    &::after {
      position: absolute;
      left: 50%;
      top: 52%;
      content: "";
      width: 11px;
      height: 11px;
      transform: translate(-50%, -50%);
      background-color: rgba(50, 144, 196, 1);
      border-radius: 10px;
    }
  }

  &.topcico {
    &::after {
      left: 14%;
    }
  }
}
</style>